module.exports = __webpack_public_path__ + "3a406a875ea9a340a15f2938871004a3.svg";